import axios from 'axios';
import { SET_ADD_RESOURCE_REQUEST,
        SET_ADD_RESOURCE_SUCCESS,
        SET_ADD_RESOURCE_ERROR,
        SET_REMOVE_RESOURCE,
        SET_INCLUDE_RESOURCE
 } from './../../../constants/closeLoop/apmDashboard/listResourcesConstants';


export const getResources = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_ADD_RESOURCE_REQUEST});
        const url = `/get/running/containers/instance?instance_id=${payload}`;
        axios.get(url).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_ADD_RESOURCE_SUCCESS, payload: response.data})
            } else {
                dispatch({type: SET_ADD_RESOURCE_ERROR, payload: response.message})
            }
        }).catch((error) => {
            console.error(error);
            dispatch(
                {type: SET_ADD_RESOURCE_ERROR,
                payload: error.response.data.message});
        })
    } catch(error) {
        console.error(error);
        dispatch({type: SET_ADD_RESOURCE_ERROR, payload: error.message});
    }
}

export const removeResource = (resource) => (dispatch) => {
    dispatch({type: SET_REMOVE_RESOURCE, item: resource})
};

export const includeResource = (resource) => (dispatch) => {
    dispatch({type: SET_INCLUDE_RESOURCE, payload: resource});
};